/* eslint-disable react/no-unknown-property */
import React from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls, Stars } from "@react-three/drei";
import * as THREE from "three";
import { useRef } from "react";

const RotatingEarth = () => {
  const earthRef = useRef<THREE.Mesh>(null);

  useFrame(() => {
    if (earthRef.current) {
      earthRef.current.rotation.y += 0.0001;
    }
  });

  return (
    <mesh ref={earthRef} position={[4, -2.5, 0]}>
      <sphereGeometry args={[2, 32, 32]} />
      <meshStandardMaterial
        map={new THREE.TextureLoader().load(
          "https://assets.science.nasa.gov/content/dam/science/esd/eo/content-feature/bluemarble/images/land_ocean_ice_cloud_2048.jpg"
        )}
      />
    </mesh>
  );
};

const Earth: React.FC = () => {
  return (
    <div className="earth-canvas">
      <Canvas camera={{ position: [0, 0, 6], fov: 45 }}>
        <ambientLight intensity={0.4} />
        <directionalLight position={[5, 3, 5]} intensity={2} />
        <Stars />
        <RotatingEarth />
        <OrbitControls enableZoom={false} autoRotate={false} />
      </Canvas>
    </div>
  );
};

export default Earth;
